import React from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./contexts/AuthContext";
import Dashboard from "./pages/Dashboard";
import ContactUsDetails from "./pages/ContactUsDetails";
import SEOEnquiryDetails from "./pages/WebsitePerfomanceDetails"
import NewContactEnquiries from "./pages/NewContactEnquiries";
import KMWEmployees from "./pages/KMWEmployees";
import Login from "./pages/Login";
// Forgot-password feature disabled — no entry point on the Login page currently.
// Uncomment this import + the route/array entries below to re-enable.
// import ForgotPassword from "./pages/ForgotPassword";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import SuperAdminRoute from "./SuperAdminRoute";
import NotFound from "./pages/NotFound";
import SessionExpiredModal from "./components/SessionExpiredModal";

function App() {
  const location = useLocation();

  // In routes jaha Header/Footer nahi chahiye
  // "/forgot-password" removed while the feature is disabled — add it back when re-enabling.
  const noHeaderFooterRoutes = ["/log-in"];

  // Agar current path koi bhi defined route se match nahi hota => NotFound page hai
  const isNotFound = !["/", "/contact-us-details", "/log-in","/seo-enquiry-details","/new-contact-enquiries","/kmw-employees"].includes(location.pathname);

  const hideHeaderFooter = noHeaderFooterRoutes.includes(location.pathname) || isNotFound;

  return (
    <AuthProvider>
      {!hideHeaderFooter && <Header />}
      <div className="main-section">
        <ToastContainer />
        <Routes>
          <Route path="/" element={<PrivateRoute element={Dashboard} />} />
          <Route
            path="/contact-us-details"
            element={<PrivateRoute element={ContactUsDetails} />}
          />
          <Route
            path="/seo-enquiry-details"
            element={<PrivateRoute element={SEOEnquiryDetails} />}
          />
          <Route
            path="/new-contact-enquiries"
            element={<PrivateRoute element={NewContactEnquiries} />}
          />
          <Route
            path="/kmw-employees"
            element={<SuperAdminRoute element={KMWEmployees} />}
          />
          <Route path="/log-in" element={<PublicRoute element={Login} />} />
          {/* Forgot-password route disabled — see import comment above. */}
          {/* <Route
            path="/forgot-password"
            element={<PublicRoute element={ForgotPassword} />}
          /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!hideHeaderFooter && <Footer />}
      <SessionExpiredModal />
    </AuthProvider>
  );
}

export default App;



// import React from "react";
// import "./App.css";
// import { Route, Routes, useLocation } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { AuthProvider } from "./contexts/AuthContext";
// import Dashboard from "./pages/Dashboard";
// import ContactUsDetails from "./pages/ContactUsDetails";
// import Login from "./pages/Login";
// import SignUp from "./pages/SignUp";
// import ForgotPassword from "./pages/ForgotPassword";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
// import PrivateRoute from "./PrivateRoute";
// import PublicRoute from "./PublicRoute";

// function App() {
//   const location = useLocation();
//   const noHeaderFooterRoutes = [
//     "/log-in",
//     //  "/sign-up",
//     "/forgot-password",
//   ];

//   return (
//     <AuthProvider>
//       {!noHeaderFooterRoutes.includes(location.pathname) && <Header />}
//       <div className="main-section">
//         <ToastContainer />
//         <Routes>
//           <Route path="/" element={<PrivateRoute element={Dashboard} />} />
//           <Route
//             path="/contact-us-details"
//             element={<PrivateRoute element={ContactUsDetails} />}
//           />

//           {/* Restrict login/signup/forgot-password for logged-in users */}
//           <Route path="/log-in" element={<PublicRoute element={Login} />} />
//           {/* <Route path="/sign-up" element={<PublicRoute element={SignUp} />} /> */}
//           <Route
//             path="/forgot-password"
//             element={<PublicRoute element={ForgotPassword} />}
//           />
//         </Routes>
//       </div>
//       {!noHeaderFooterRoutes.includes(location.pathname) && <Footer />}
//     </AuthProvider>
//   );
// }

// export default App;

// // import React from "react";
// // import "./App.css";
// // import { Route, Routes, useLocation } from "react-router-dom";
// // import { ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { AuthProvider } from "./contexts/AuthContext";
// // import Dashboard from "./pages/Dashboard";
// // import ContactUsDetails from "./pages/ContactUsDetails";
// // import Login from "./pages/Login";
// // import SignUp from "./pages/SignUp";
// // import ForgotPassword from "./pages/ForgotPassword";
// // import Header from "./components/Header";
// // import Footer from "./components/Footer";
// // import PrivateRoute from "./PrivateRoute";
// // import PublicRoute from "./PublicRoute";

// // function App() {
// //   const location = useLocation();
// //   const noHeaderFooterRoutes = ["/log-in", "/sign-up", "/forgot-password"];

// //   return (
// //     <AuthProvider>
// //       {!noHeaderFooterRoutes.includes(location.pathname) && <Header />}
// //       <div className="main-section">
// //         <ToastContainer />
// //         <Routes>
// //           {/* <Route path="/" element={<PrivateRoute element={Dashboard} />} /> */}
// //           <Route
// //             path="/"
// //             element={<PrivateRoute element={ContactUsDetails} />}
// //           />

// //           {/* Public Routes - Only accessible if NOT logged in */}
// //           <Route path="/log-in" element={<PublicRoute element={Login} />} />
// //           <Route path="/sign-up" element={<PublicRoute element={SignUp} />} />
// //           <Route
// //             path="/forgot-password"
// //             element={<PublicRoute element={ForgotPassword} />}
// //           />
// //         </Routes>
// //       </div>
// //       {!noHeaderFooterRoutes.includes(location.pathname) && <Footer />}
// //     </AuthProvider>
// //   );
// // }

// // export default App;
